import { useCallback, useState, useMemo } from 'react';

import { useNavigate } from 'react-router-dom';

import FORM_TYPES from '../lib/formTypes';

const DIALOG_EDIT_PRODUCT_TITLE = 'Edición de producto';
const DIALOG_NEW_PRODUCT_TITLE = 'Creación de producto';

const DIALOG_TITLE = {
  [FORM_TYPES.new]: DIALOG_NEW_PRODUCT_TITLE,
  [FORM_TYPES.edit]: DIALOG_EDIT_PRODUCT_TITLE,
};

function useDialog({ formType, resetForm = () => {} }) {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState('');
  const navigate = useNavigate();
  const title = useMemo(() => DIALOG_TITLE[formType], []);
  const handleClose = useCallback(() => {
    setOpen(false);
    if (formType === FORM_TYPES.new) {
      navigate('/catalogs/products');
    } else {
      resetForm();
    }
  }, [resetForm]);
  return { dialog: { open, setOpen, title, content, setContent, handleClose } };
}
export default useDialog;
